<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters, useMapGetter } from 'dashboard/composables/store';

import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import CampaignDrawer from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignDrawer.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';
import SMSCampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/SMSCampaignEmptyState.vue';

const { t } = useI18n();
const getters = useStoreGetters();

const drawerRef = ref(null);
const isDrawerOpen = ref(false);
const confirmDeleteCampaignDialogRef = ref(null);
const selectedCampaign = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const SMSCampaigns = computed(() => getters['campaigns/getSMSCampaigns'].value);

const hasNoSMSCampaigns = computed(
  () => SMSCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const editingCampaign = ref(null);

// A gaveta pede confirmação antes de trocar de campanha com alterações sem salvar.
const handleCreate = () => {
  drawerRef.value.runGuarded(() => {
    editingCampaign.value = null;
    isDrawerOpen.value = true;
  });
};

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.SMS.HEADER_TITLE')"
    :button-label="t('CAMPAIGN.SMS.NEW_CAMPAIGN')"
    @click="handleCreate"
  >
    <CampaignList
      v-if="isFetchingCampaigns || !hasNoSMSCampaigns"
      :campaigns="SMSCampaigns"
      :title="t('CAMPAIGN.SMS.HEADER_TITLE')"
      :is-loading="isFetchingCampaigns"
      @delete="handleDelete"
    />
    <SMSCampaignEmptyState
      v-else
      :title="t('CAMPAIGN.SMS.EMPTY_STATE.TITLE')"
      :subtitle="t('CAMPAIGN.SMS.EMPTY_STATE.SUBTITLE')"
    />
    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
    <template #drawer>
      <CampaignDrawer
        ref="drawerRef"
        v-model:open="isDrawerOpen"
        type="sms"
        :campaign="editingCampaign"
      />
    </template>
  </CampaignLayout>
</template>
